<div [id]="id" [class]="class">
  <ng-content select="accordion-tab"></ng-content>
</div>
